__turbopack_context__.v({
  "indicator": "gloss-indicator-module__vquFOG__indicator",
  "mist": "gloss-indicator-module__vquFOG__mist",
});
